export const DEFAULT_PRODUCTS_FEED_LAYOUT = "grid";

export const resolveProductsFeedLayout = (options = {}, device) => {
  const desktopLayout =
    options["products-layout"] || DEFAULT_PRODUCTS_FEED_LAYOUT;

  if (device === "mobile") {
    return options["products-layout-mobile"] || desktopLayout;
  }

  return desktopLayout;
};

export const resolveProductsFeedLayoutMobile = (options = {}) =>
  resolveProductsFeedLayout(options, "mobile");
